import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { readStatusOptions } from 'modules/FileManagerV2/constants/fileManagerConstants';

function ReadStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  const handleReadStatusChange = (e) => {
    onFilterChange({
      target: { name: 'is_read', value: e.value },
      value: e.value,
    });
    setSelectedRows([]);
  };

  return (
    <>
      <div className="d-flex flex-column filter-wraper">
        <Dropdown
          options={readStatusOptions}
          value={fileManagerFilters?.is_read}
          placeholder="By Read Status"
          className="file-manager-select"
          onChange={handleReadStatusChange}
          name="is_read"
        />
      </div>
    </>
  );
}

export default ReadStatusFilter;
